import React from "react";

import { DumpYardTemplateType } from "../../../models";
import { DumpYardTemplatesTable } from "../DumpYardTemplatesTable/DumpYardTemplatesTable";
import { DumpEventReceiptsTable } from "../DumpEventReceiptsTable/DumpEventReceiptsTable";

// A tab is either one of the three template types or the special "receipts" tab.
export type DumpYardTabId = DumpYardTemplateType | "receipts";

export interface DumpYardTab {
  label: string;
  // Doubles as the React key and the URL path segment under /dump_yards.
  id: DumpYardTabId;
  element: React.ReactNode;
}

// Single source of truth for the horizontal subtabs (DumpYardsView) and the
// nested routes (App.tsx). Dump Yards is first, so it is the default landing tab.
export const DUMP_YARD_TABS: DumpYardTab[] = [
  {
    label: "Dump Yards",
    id: DumpYardTemplateType.DUMP_YARD,
    element: <DumpYardTemplatesTable type={DumpYardTemplateType.DUMP_YARD} />,
  },
  {
    label: "Storage",
    id: DumpYardTemplateType.STORAGE,
    element: <DumpYardTemplatesTable type={DumpYardTemplateType.STORAGE} />,
  },
  {
    label: "Quick Stops",
    id: DumpYardTemplateType.QUICK_STOP,
    element: <DumpYardTemplatesTable type={DumpYardTemplateType.QUICK_STOP} />,
  },
  {
    label: "Receipts",
    id: "receipts",
    element: <DumpEventReceiptsTable />,
  },
];
